import type {
  CreateOAuthClientInput,
  CreatedOAuthClient,
  OAuthClientView,
} from '@logspot-platform/platform-types';
import { api } from './api-client';

type Envelope<T> = { data: T };

// Org-owned OAuth clients (client_credentials). Backend routes live at
// /api/oauth-clients (owner/admin only); the secret is returned only on create and rotate.
export const OAuthClientsService = {
  list: async (): Promise<OAuthClientView[]> => {
    const res = await api.get<Envelope<OAuthClientView[]>>('/oauth-clients');
    return res.data;
  },
  create: async (input: CreateOAuthClientInput): Promise<CreatedOAuthClient> => {
    const res = await api.post<Envelope<CreatedOAuthClient>>('/oauth-clients', input);
    return res.data;
  },
  rotate: async (id: string): Promise<CreatedOAuthClient> => {
    const res = await api.post<Envelope<CreatedOAuthClient>>(
      `/oauth-clients/${id}/rotate`,
      {},
    );
    return res.data;
  },
  remove: async (id: string): Promise<void> => {
    await api.delete(`/oauth-clients/${id}`);
  },
};
